import React, { Component } from 'react';
import SpinToWin from '../Wheel/Wheel';
import Form from '../Form/Form';
import smoothScroll from '../../utils/smoothScroll'

class App extends Component {
  constructor( props ) {
    super( props );

    this.state = { 
      segmentTarget: null,
      message: null,
      showMessage: true,
      formDisabled: false,
      isWinner: false,
      spinInProgress: false,
      isSpinLimitReached: false
    };

    this.handleSpinStart = this.handleSpinStart.bind(this);
    this.handleSpinComplete = this.handleSpinComplete.bind(this);
    this.handleData = this.handleData.bind(this);

    this.breakpoint = window.matchMedia( `(max-width: ${ this.props.config.breakpoint })` );
  }

  componentDidMount(){
    // Are we within an iFrame?
    if( window.self !== window.top ) {
      this.waitForIframe().then(() => {
        window.parentIFrame.getPageInfo( info => this.parent = info );
      });
    }
  }

  waitForIframe() {
    return new Promise(function (resolve, reject) {
        (function wait(){
            if (window.parentIFrame) return resolve();
            setTimeout(wait, 30);
        })();
    });
  }

  componentDidUpdate( prevProps, prevState ) {
    if( this.state.spinInProgress !== prevState.spinInProgress ) {
      this.handleSpinStateChange();
    } 
  }

  handleSpinStateChange(){
    if( !this.breakpoint.matches ) return;

    const scrollTop = this.parent && typeof this.parent.scrollTop !== 'undefined' ? this.parent.scrollTop : window.pageYOffset;

    smoothScroll( this.state.spinInProgress ? this.wheel : this.form, 1000, scrollTop );
  }

  handleSpinStart(){
    this.setState({
      formDisabled: true,
      showMessage: false,
      spinInProgress: true
    });
  }

  handleSpinComplete() {
    this.setState({
      segmentTarget: null,
      showMessage: true,
      formDisabled: this.state.isWinner || this.state.isSpinLimitReached,
      spinInProgress: false
    });
  }

  handleData( data ) {
    this.setState({ 
      segmentTarget: data.segment,
      message: data.message,
      isWinner: data.isWinner,
      isSpinLimitReached: data.isSpinLimitReached,
      formDisabled: data.isSpinLimitReached || data.isWinner
    });
  }

  render() {
    const classNames = this.state.spinInProgress ? 'is-spinning' : '';

    return (
      <div className={ `SpinToWin ${ classNames }` }>
        <div className="SpinToWin-inner">

          <div className="SpinToWin-form" ref={ (el) => this.form = el }>
            <Form
              onSubmit={ this.handleData } 
              action={ this.props.config.endPoint }
              competitionId={ this.props.config.competitionId }
              recapchaKey={ this.props.config.recapchaKey }
              isDisabled={ this.state.formDisabled } />

            { this.state.showMessage &&
              <p className="SpinToWin-message">
                <strong>{ this.state.message || this.props.config.initialMessage }</strong>
              </p>
            }
          </div>

          <div className="SpinToWin-wheel" ref={ (el) => this.wheel = el }>
            <SpinToWin
              segmentTarget={ this.state.segmentTarget }
              assetConfig={ this.props.config.assets }
              duration={ this.props.config.duration }
              spinCount={ this.props.config.spinCount }
              onStart={ this.handleSpinStart }
              onComplete={ this.handleSpinComplete }/>
          </div>

        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js